const $ = jQuery

export default function ActivitiesArchive() {
    const ACTIVITIES_CONTAINERS = document.querySelectorAll('.mtt-activities')

    if (ACTIVITIES_CONTAINERS.length) {
        for (let i = 0; i < ACTIVITIES_CONTAINERS.length; i++) {
            const CONTAINER = ACTIVITIES_CONTAINERS[i]
            const PAGINATION_FUNCTIONALITY = new FilterEvent(CONTAINER)
        }
    }
}

class FilterEvent {
    constructor(container) {
        this.loader = $('#loader')
        this.container = container
        this.paginationItems = '.mtt-pagination ul li a'
        this.destination = $(this.container.querySelector('.mtt-activities__inner'))
        this.paginationDestination = $(this.container.querySelector('.mtt-pagination-wrapper'))
        this.activities_page_number = 0
        this.activities_category = 0

        // Click on pagination
        $(this.container).on('click', this.paginationItems, (e) => {
            // Prevent default link behavior
            e.preventDefault()

            // Update page number
            this.activities_page_number = e.currentTarget.getAttribute('data-page')

            // Run ajax request
            this.getActivities()
        })

        // Select option from select field
        $(this.container).on('change', '.mtt-activities__select', (e) => {

            // Update category
            this.activities_category = e.currentTarget.value
            this.activities_page_number = 0

            // Run ajax request
            this.getActivities()
        })
    }


    // Ajax request function
    getActivities() {
        // Show loader
        this.loader.addClass('show')

        // Set ajax data
        const data = {
            action: 'filter_activities',
            page_number: this.activities_page_number,
            category: this.activities_category,
            is_swiper: this.container.classList.contains('mtt-activities--swiper'),
        }

        // Ajax call
        jQuery.post(main_theme_objects.ajax_url, data, (response) => {
            if (response != 0) {
                // Post response
                if (response.posts !== '') {
                    this.destination.html(response.posts)
                } else {
                    this.destination.html('<p class="no-posts">' + this.destination.attr('data-no-posts') + '</p>')
                }

                // Pagination response
                this.paginationDestination.html(response.pagination)

                // Hide loader
                this.loader.removeClass('show')
            }
        })
    }
}